import { ParkingCarType } from '../types/ParkingCarType';
import { ParkingPlaceType } from '../types/ParkingPlaceType';
import { ApprovementStatus } from '../types/ApprovementStatus';

/** Normalize DataGrid / API status (number, numeric string, or enum name). */
const resolveApprovementStatus = (
  raw: unknown
): ApprovementStatus | undefined => {
  const value =
    raw !== null &&
    typeof raw === 'object' &&
    'value' in (raw as Record<string, unknown>)
      ? (raw as { value?: unknown }).value
      : raw;

  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  if (typeof value === 'number') {
    return value as ApprovementStatus;
  }

  if (typeof value === 'string') {
    const asNumber = Number(value);
    if (!Number.isNaN(asNumber) && value.trim() !== '') {
      return asNumber as ApprovementStatus;
    }
    if (value in ApprovementStatus) {
      return ApprovementStatus[
        value as keyof typeof ApprovementStatus
      ] as ApprovementStatus;
    }
  }

  return undefined;
};

export const translateApprovementStatus = (raw: unknown): string => {
  const status = resolveApprovementStatus(raw);
  switch (status) {
    case ApprovementStatus.Draft:
      return 'Piszkozat';
    case ApprovementStatus.Rejected:
      return 'Elutasítva';
    case ApprovementStatus.ApprovedSecondLevel:
      return 'Elfogadva';
    case ApprovementStatus.SentToApproval:
    case ApprovementStatus.ApprovedFirstLevel:
      return 'Jóváhagyásra vár';
    case ApprovementStatus.DeletedFirstLevel:
    case ApprovementStatus.SentToDelete:
      return 'Törlésre vár';
    case ApprovementStatus.DeletedSecondLevel:
    case ApprovementStatus.DeletedPermanently:
      return 'Archivált';
    default:
      return 'Ismeretlen';
  }
};

export const translateParkingPlaceType = (type: ParkingPlaceType) => {
  switch (type) {
    case ParkingPlaceType.Normal:
      return 'Normál';
    case ParkingPlaceType.Bicycle:
      return 'Bicikli';
    case ParkingPlaceType.Disabled:
      return 'Mozgássérült';
    case ParkingPlaceType.Bus:
      return 'Busz';
    case ParkingPlaceType.Emergency:
      return 'Vészhelyzet';
    case ParkingPlaceType.Extraordinary:
      return 'Különleges';
    case ParkingPlaceType.Family:
      return 'Családi';
    case ParkingPlaceType.Taxi:
      return 'Taxi';
    default:
      return '';
  }
};
export const translateParkingCarType = (type: ParkingCarType) => {
  switch (type) {
    case ParkingCarType.passengerCar:
      return 'Személyautó';
    case ParkingCarType.lightTruck:
      return 'Kisteherautó';
    case ParkingCarType.heavyTruck:
      return 'Teherautó';
    case ParkingCarType.bus:
      return 'Busz';
    case ParkingCarType.motorcycle:
      return 'Motorkerékpár';
    case ParkingCarType.motorhome:
      return 'Lakóautó';
    case ParkingCarType.trailer:
      return 'Pótkocsi';
    default:
      return '';
  }
};
